<template>
	<Container :active='4'>
		<div class="mainbody" v-if='!loading'>
		    <div v-if='true' class="content">
		    	<div class="menu">
		    		<template v-for='menu in menus'>
		    			<div class="menu-item" :class='{active:activeCode == menu.Code}'  @click='cellClicked(menu)'>{{menu.Name}}</div>
		    			<!-- <div v-for='subMenu in menu.Childs' class="menu-item sub-menu" :class='{active:activeCode == subMenu.Code}'  @click='cellClicked(subMenu)'>{{subMenu.Label}}</div> -->
		    		</template>
			    </div>
			    <div class="right-files-box">
			    	<!-- <div class="tabs" v-if='subMenus.length'>
						<div v-for='item in subMenus' class="tab" :class='{"active-tab":activeSubMenu.Code == item.Code}' @click='changeTab(item)'>{{item.Name}}</div>
					</div> -->
			    	<div class="files">
			    	
		    	    	<template v-if='false'>
		    	    		<div :ref='"el"+index' class="file-box" v-for='(file,index) in files' @mouseenter="mouseenter" @mouseleave="mouseout('el'+index)">
		    	    			<img v-lazysrc="file.VideoCoverURL" :data-default='require("@/assets/defaultImg.png")'>
		    					<div class="cover">
		    	    				<p class="title">{{file.Name}}</p>
		    	    				<div class="btn">
		    	    					<Icon size='20' color='white' type="md-download" />
		    	    				</div>
		    	    				<div class="btn" @click='showUrl=file.VideoCoverURL;showImg=true;'>
		    	    					<Icon size='20' color='white' type="md-qr-scanner" />
		    	    				</div>
		    	    			</div>
		    	    		</div>
		    	    	</template>
		    	    	<template v-if='showListView'>
		    	    		<div class="pdf-jpg-box" v-for='file in files' :key='file.Code'>
		    	    			<img class="icon" :src="file.CoverURL">
		    	    			<div class="right-box">
		    	    				<p class="name">{{file.Name}}</p>
		    	    				<a :href='file.DownloadURL' class='button-primary btn' type='primary'>下載</a>
		    	    			</div>
		    	    		</div>
		    	    	</template>
		    	    	<template v-else>
		    				<div class="videos" v-for='file in files' :key='file.Code'>
		    					<div class="video-box">
		    						<a @click='showFile(file)' class="cover zoom-out">
		    							<img v-lazysrc="file.CoverURL" :data-default='require("@/assets/defaultImg.png")' alt="" class="cover-img">
		    							<div class="mask"></div>
		    							<img src="@/assets/play.png" alt="" class="play">
		    						</a>
		    						<div class="bottom">
		    							<p class="name">{{file.Name}}</p>
		    							<a @click='download(file)'  class="button-primary detail">下載</a>
		    						</div>
		    					</div>
		    				</div>
		    	    	</template>
			    	</div>
			    </div>
			    
		    </div>
		    <div v-else class="content category-box">
		    	<div class="category" :key='index' v-for='(item,index) in category'>
					<div class="img-box zoom-out" @click='cellClicked(item)'>
						<img v-lazysrc="item.Pic" :data-default='require("@/assets/defaultImg.png")'>
					</div>
					<p class="category-name"><span @click='cellClicked(item)'>{{item.Name}}</span></p>
				</div>
		    </div>
		</div>
		<LoadMore v-lazyFunc='loadMoreFiles' v-if='filesLoading'/>
		<Modal v-model="showImg" width='1056'  footer-hide>
			<div style="margin:auto;">
				<img class="showImg" :src="showUrl" :data-default='require("@/assets/defaultImg.png")'>
			</div>
	    </Modal>
	</Container>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				activeSubMenu:{},
				files:[],
				showImg:false,
				showUrl:'',
				filesLoading:false,
				startIndex:1,
				pageSize:20,
				category:[],
				menus:[],
				subMenus:[],
				activeCode:'',
				loading:true,
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{
			'$route'(value){
				this.initData()
			},
		},
		mixins:[],
		components: {

		},
		computed: {
			...mapState({

			}),
			showListView(){
				let showList = true
				for (var i = 0; i < this.files.length; i ++ ) {
					let mediaType = this.files[i].MediaType
					if (mediaType.toLowerCase() == 'video') {
						showList = false
					} else {
						return true
					}
				}
				return showList
			}
		},
		methods: {
			...mapActions([
				'getFilesAction',
				'getDownloadMenusAction',
				'getCommunityCatalogAction',
				'reportFileDownloadAction',
			]),
			mouseenter(event){
				let {x,y} = event
				let el = event.toElement
				let coverEl = el.children[1]
				let react = el.getBoundingClientRect()
				if (Math.abs(x - react.x) < 10) { //leftIn
					coverEl.classList.add('leftIn')
				} else if (Math.abs(x - react.x - react.width) < 10) { //rightIn
					coverEl.classList.add('rightIn')
				} else if (Math.abs(y - react.y) < 10) { //topIn
					coverEl.classList.add('topIn')
				} else if(Math.abs(y - react.y - react.height) < 10) { //bottomIn
					coverEl.classList.add('bottomIn')
				} else {
					coverEl.classList.add('bottomIn')
				}
			},
			mouseout(ref){
				let el = this.$refs[ref][0]
				let coverEl = el.children[1]
				console.log('mouseout')
				coverEl.classList.remove('leftIn','rightIn','topIn','bottomIn')
			},
			async initData(){
				this.loading = true;
				this.startIndex = 1;
				this.filesLoading = false
				this.files = []
				let code = this.$route.query?.code
				this.activeCode = code
				if (!this.menus.length) {
					this.menus = await this.getDownloadMenusAction('DT_WS_DownloadCatalog')
				}
					this.subMenus = await this.getDownloadMenusAction(code)
					this.activeSubMenu = this.subMenus[0]||{}
					let depth = this.$route.query?.depth || 1
					let response1 = await this.getFilesAction({
						QW:'',
						code:this.activeSubMenu?.Code || code,
						depth,
						keys:'',
						startIndex:this.startIndex,
						pageSize:this.pageSize,
						isCount:0,

					});
					this.files = response1.Files || []
					if (this.files.length < this.pageSize) {
						this.filesLoading = false
					} else {
						this.filesLoading = true
					}
				// }
				this.loading = false;
			},
			cellClicked(item){
				
				this.startIndex = 1;
				this.routerPush({
					path:'/download/album',
					query:{
						code:item.Code,
					},
				})
			},
			changeTab(tab){
				if (tab.Code == this.activeSubMenu.Code) {
					return
				}
				this.activeSubMenu = tab
				this.startIndex = -19;
				this.files = []
				this.loadMoreFiles()
			},
			showFile(file){
				this.routerPush({
					path:'/download/album/detail',
					query:{
						code:file.Code,
					},
					params:{
						file,
					}
				})
			},
			async loadMoreFiles(){
				let code = this.$route.query?.code
				let depth = this.$route.query?.depth || 1
				this.startIndex += this.pageSize
				this.filesLoading = false
				let response1 = await this.getFilesAction({
					QW:'',
					code:this.activeSubMenu?.Code || code,
					depth,
					keys:'',
					startIndex:this.startIndex,
					pageSize:this.pageSize,
					isCount:0,

				});
				if (response1.Files) {
					this.files =[...this.files ,...response1.Files]
				}
				if (response1.Files?.length >= this.pageSize) {
					setTimeout(()=>{
						this.filesLoading = true
					}, 500)
				}
			},
			download(file){
				this.reportFileDownloadAction({code:file.Code,flag:2})
				var link = document.createElement('a');
				//設置下載的文件名
				link.setAttribute("download", file.Name);
				link.style.display = 'none';
				//設置下載路徑
				link.href = file.DownloadURL;
				//觸發點擊
				document.body.appendChild(link);
				link.click();
				//移除節點
				document.body.removeChild(link);
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/common';
	@import '@/style/mixin';
	.container {
		.mainbody {
		    margin: auto;
		    margin-top: 20px;
		    display: flex;
		    // max-width: 1560px;
		    .menu {
		      width: 2.4rem;
		    }
		    .content {
		      width:88vw;
		      margin:auto;
		      display:flex;
		      flex-wrap: wrap;
		    }
		    .right-files-box {
		    	flex:1;
		    }
		    .files {
		    	flex:1;
		    	display:flex;
		    	flex-wrap: wrap;
		    	position: relative;
		    }
		    .category-box {
				justify-content: space-between;
				margin:0 6.5vw;
				margin-bottom: 40px;
			}
		}
	}
	.pdf-jpg-box {
		padding-left: 0.3rem;
		width:33%;
		display:flex;
		margin-bottom: 0.3rem;
		.icon {
			width:0.7rem;
			height:0.9rem;
			margin-right: 0.2rem;
		}
		.right-box {
			display:flex;
			flex-direction: column;
			padding-right: 0.3rem;
			.name {
				margin-top: 10px;
				@include fontSize($font-size-14);
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				word-break: break-all;
				-webkit-line-clamp: 2;//嚮顯示多少行就給多大值
				-webkit-box-orient: vertical; 
			}
			.btn {
				width:80px;
				height:25px;
				margin-top: 10px;
				border-radius: 30px;
			}
		}
	}
	.file-box {
		height:200px;
		margin: 5px;
		position:relative;
		img {
			display:block;
			width:auto;
			height:200px;
			width: 300px;
			object-fit: cover;
		}
		.leftIn {
			animation: slideFromLeft .2s ease-in;
			animation-fill-mode: forwards;
		}
		.rightIn {
			animation: slideFromRight .2s ease-in;
			animation-fill-mode: forwards;
		}
		.topIn {
			animation: slideFromTop .2s ease-in;
			animation-fill-mode: forwards;
		}
		.bottomIn {
			animation: slideFromBottom .2s ease-in;
			animation-fill-mode: forwards;
		}
		.cover {
			position: absolute;
			width:100%;
			height:30px;
			bottom: 0;
			opacity: 0;
			box-shadow: 0 -5px 8px 0px rgba(0, 0, 0, 0.2);
			background-color: rgba(0,0,0,0.4);
			display:flex;
			align-items: center;
			justify-content: flex-end;
			.title {
				color: white;
				font-weight: bold;
				line-height: 30px;
				position: absolute;
				left:10px;
				flex:1;
				right:60px;
				overflow: hidden;
    			text-overflow: ellipsis;
			}
			.btn {
				width:30px;
				cursor: pointer;
				height:30px;
				display:flex;
				align-items: center;
				right:10px;
			}
		}
	}
	.showImg {
		display:block;
		max-width: 100%;
		margin: auto;
	}
	.videos {
		width: 33%;
	}
	.video-box {

		width:19vw;
		// height:17.1vw;
		margin: 0 1.5vw;
		margin-bottom: 0.3rem;
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.2);
		.cover {
			height:11.25vw;
			display: flex;
			justify-content: center;
			align-items: center;
			position:relative;
			cursor: pointer;
			.cover-img {
				width:100%;
				height:100%;
				object-fit: cover;
			}
			.mask {
				position: absolute;
				width: 100%;
				height:100%;
				background-color: rgba(0,0,0,0.2);
			}
			.tag {
				position: absolute;
				right: 10px;
				top: 10px;
				background-color: $theme-color;
				color:white;
				padding: 3px 20px;
				border-radius: 20px;
			}
			.play {
				// left: calc(9.5vw - 25px);
				// top:calc(5.5vw - 25px);
				position:absolute;
				width:50px;
				height:50px;
			}
		}
		.bottom {
			display: flex;
			margin: 0.2rem 0.1rem;
			justify-content: space-between;
			align-items: center;
			.name {
				@include fontSize($font-size-15);
				text-overflow:ellipsis;
				overflow: hidden;
				white-space: nowrap;
			}
			.detail {
				margin-left: 5px;
				min-width: 0.8rem;
				padding:3px 10px;
				border-radius: 20px;
			}

		}
	}
	.menu {
      width: 2.4rem;
      max-height: 100vh;
      overflow-y:scroll;
      .menu-item {
      	@include fontSize($font-size-14);
        cursor: pointer;
        padding: 14px 24px;
        border-right: 1px solid #ddd;
        .icon {
          margin-right: 6px;
        }
      }
      .sub-menu {
      	padding-left: 40px;
      }
      .active {
        color: #B176C5;
        background: #fef0ff;
        border-right: 2px solid #B176C5;
      }
    }
	.category {
		width: 37.5vw;
		margin-top: 40px;
		.img-box {
			width:100%;
			height:23.44vw;
			border-radius: 20px;
			overflow: hidden;
			cursor: pointer;
		}
		img {
			width: 100%;
			height:100%;
			object-fit: cover;
		}
		.category-name {
			text-align: center;
			margin-top: 2.6vw;
			@include fontSize($font-size-20);
			span {
				cursor: pointer;
			}
			.num {
				color:$theme-color;
			}
		}
	}
	.tabs {
		display:flex;
		align-items: center;
		justify-content: space-around;
		border-bottom:1px solid #eee;
		margin-bottom: 0.4rem;
		margin-left: 0.2rem;
		position: sticky;
		top:1rem;
		z-index: 100;
		background-color: white;
		.tab {
			@include fontSize($font-size-15);
			padding: 0.1rem 0.2rem;
			cursor: pointer;
		}
		.active-tab {
			border-bottom:2px solid $theme-color;
			color:$theme-color;
		}
	}
	@media (max-width: 768px){
		.menu {
			display:none;
		}
		.tabs {
			margin-left: 0;
		}
		.container {
			.mainbody {
				.content {
					width: 95vw;
				}
				.files {
					justify-content: space-between;
				}
			}
		}
		.videos {
			width: 45vw;
			.video-box {
				width: 100%;
				margin:0;
				margin-bottom:0.5rem;
				.cover {
					height:40px;
					height: 28vw;
				}
				.bottom {
					.detail {
						min-width:44px;
					}
				}
			}
		}
		.pdf-jpg-box {
			width: 45vw;
			.icon {
				width:2.3rem;
				height:3rem;
				margin-right: 0.5rem;
			}
		}
		.tabs {
			top: 2rem;
		}
	}
	@keyframes slideFromBottom {
		from {
			bottom:-30px;
			opacity: 0;
		}
		to {
			bottom: 0;
			left:0;
			opacity: 1;
		}
	}
	@keyframes slideFromTop {
		from {
			bottom:30px;
			opacity: 0;
		}
		to {
			bottom: 0;
			left:0;
			opacity: 1;
		}
	}
	@keyframes slideFromLeft {
		from {
			left:-100%;
			opacity: 0;
		}
		to {
			bottom: 0;
			left:0;
			opacity: 1;
		}
	}
	@keyframes slideFromRight{
		from {
			right:-100%;
			opacity: 0;
		}
		to {
			bottom: 0;
			left:0;
			right:0;
			opacity: 1;
		}
	}

</style>